/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ConsumeOauthHandoffInput,
  ConsumeOauthHandoffParams,
  OauthHandoffConsumeOutput,
  OauthHandoffErrorOutput,
  OauthHandoffShowOutput,
  SchemaValidationErrorResponse,
  ShowOauthHandoffParams
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * Returns the provider for a pending OAuth handoff without consuming it. Requires a matching signed `oauth_handoff_nonce` cookie.
 * @summary Show OAuth handoff
 */
export const showOauthHandoff = (
    params: MaybeRefOrGetter<ShowOauthHandoffParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<OauthHandoffShowOutput>(
      {url: `/oauth_handoff`, method: 'GET',
        params, signal
    },
      );
    }




export const getShowOauthHandoffQueryKey = (params?: MaybeRefOrGetter<ShowOauthHandoffParams>,) => {
    return [
    'oauth_handoff', ...(params ? [params] : [])
    ] as const;
    }


export const getShowOauthHandoffQueryOptions = <TData = Awaited<ReturnType<typeof showOauthHandoff>>, TError = ErrorType<SchemaValidationErrorResponse | void | OauthHandoffErrorOutput>>(params: MaybeRefOrGetter<ShowOauthHandoffParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showOauthHandoff>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getShowOauthHandoffQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showOauthHandoff>>> = ({ signal }) => showOauthHandoff(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof showOauthHandoff>>, TError, TData>
}

export type ShowOauthHandoffQueryResult = NonNullable<Awaited<ReturnType<typeof showOauthHandoff>>>
export type ShowOauthHandoffQueryError = ErrorType<SchemaValidationErrorResponse | void | OauthHandoffErrorOutput>


/**
 * @summary Show OAuth handoff
 */

export function useShowOauthHandoff<TData = Awaited<ReturnType<typeof showOauthHandoff>>, TError = ErrorType<SchemaValidationErrorResponse | void | OauthHandoffErrorOutput>>(
 params: MaybeRefOrGetter<ShowOauthHandoffParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showOauthHandoff>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShowOauthHandoffQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Resolves a pending OAuth handoff by performing the action the user picked on the dialog. Requires a matching signed `oauth_handoff_nonce` cookie. The `actionType` body parameter selects the action; valid values depend on the handoff's live state (returned by GET /oauth_handoff). Terminal actions (`change_session`, `link_to_current_user`, `create_new_user`, `cancel`) atomically consume the handoff. The deferred `sign_in` action returns a navigation URL without consuming the handoff so the user can return after authenticating.
 * @summary Consume OAuth handoff
 */
export const consumeOauthHandoff = (
    params: MaybeRefOrGetter<ConsumeOauthHandoffParams>,
    consumeOauthHandoffInput?: MaybeRefOrGetter<ConsumeOauthHandoffInput>,
 signal?: AbortSignal
) => {
      params = toValue(params);
consumeOauthHandoffInput = toValue(consumeOauthHandoffInput);

      return axiosClient<OauthHandoffConsumeOutput>(
      {url: `/oauth_handoff/consume`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: consumeOauthHandoffInput,
        params, signal
    },
      );
    }




export const getConsumeOauthHandoffMutationKey = () => ['consumeOauthHandoff'] as const;

export const getConsumeOauthHandoffMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | OauthHandoffErrorOutput>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consumeOauthHandoff>>, TError,ConsumeOauthHandoffMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof consumeOauthHandoff>>, TError,ConsumeOauthHandoffMutationVariables, TContext> => {

const mutationKey = getConsumeOauthHandoffMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof consumeOauthHandoff>>, ConsumeOauthHandoffMutationVariables> = (props) => {
          const {params,data} = props ?? {};

          return  consumeOauthHandoff(params,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConsumeOauthHandoffMutationResult = NonNullable<Awaited<ReturnType<typeof consumeOauthHandoff>>>
    export type ConsumeOauthHandoffMutationBody = ConsumeOauthHandoffInput | undefined
    export type ConsumeOauthHandoffMutationError = ErrorType<SchemaValidationErrorResponse | void | OauthHandoffErrorOutput>
    export type ConsumeOauthHandoffMutationVariables = {params: ConsumeOauthHandoffParams;data?: ConsumeOauthHandoffInput}

    /**
 * @summary Consume OAuth handoff
 */
export const useConsumeOauthHandoff = <TError = ErrorType<SchemaValidationErrorResponse | void | OauthHandoffErrorOutput>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consumeOauthHandoff>>, TError,ConsumeOauthHandoffMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof consumeOauthHandoff>>,
        TError,
        ConsumeOauthHandoffMutationVariables,
        TContext
      > => {
      return useMutation(getConsumeOauthHandoffMutationOptions(options), queryClient);
    }
